const locale = {
	ORDERS_PLANNED_VALUE: 'Fatturato previsto: {value}',
	ORDERS_PLANNED_EXPENSES: 'Costi previsti: {value}',
	ORDERS_BILLED_VALUE: 'Fatturato: {value}',
	ORDERS_BILLED_EXPENSES: 'Costi: {value}',
	ORDERS_BILLED_VALUE_MISSING: 'Fatturato: {value} (rimanenti {missingValue})',
	ORDERS_BILLED_EXPENSES_MISSING: 'Costi: {value} (rimanenti {missingValue})',
	ORDERS_BILLED_PROFIT: 'Margine: {value}',

	ERROR_DELIVERY_DATE_REQUESTED_MIN_VALUE: "La data deve essere successiva alla data d'ordine",

	DETAILS_HEADER_BUTTON_ORDERS_CREATE_REVISION: 'Crea revisione',
	DETAILS_HEADER_BUTTON_ORDERS_PUSH_TO_NAV: 'Invia a sede',
	DETAILS_HEADER_BUTTON_ORDERS_EXPORT_PDF_IT: 'Scarica report PDF IT',
	DETAILS_HEADER_BUTTON_ORDERS_EXPORT_PDF_EN: 'Scarica report PDF EN',
	DETAILS_HEADER_BUTTON_ORDERS_EXPORT_XLSX: 'Scarica report Excel',

	ORDERS_DIALOG_TITLE_ADD_OPPORTUNITY: 'Vuoi aggiungere una nuova Opportunità?',

	// #region Orders fields
	DETAILS_ORDERS_FIELD_TITLE: 'Titolo',
	DETAILS_ORDERS_FIELD_STATUS: 'Stato Ordine',
	DETAILS_ORDERS_FIELD_TYPE: 'Tipo Ordine',
	// DETAILS_ORDERS_FIELD_TITLE: 'Codice NAV',
	// DETAILS_ORDERS_FIELD_STATUS: 'Stato Ordine',
	// DETAILS_ORDERS_FIELD_TYPE: 'Tipo Ordine',
	DETAILS_ORDERS_FIELD_COMPANY: 'Cliente',
	DETAILS_ORDERS_FIELD_PERSON: 'Referente esterno',
	DETAILS_ORDERS_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_ORDERS_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_ORDERS_FIELD_SIGNDATE: 'Data',
	DETAILS_ORDERS_FIELD_RATING: 'Valutazione',
	DETAILS_ORDERS_FIELD_TOT_TAX_EXCL: 'Totale (tasse escluse)',
	DETAILS_ORDERS_FIELD_TOT_EXPENSES: 'Totale spese',
	DETAILS_ORDERS_FIELD_TAGS: 'Tag',
	DETAILS_ORDERS_FIELD_WARNING: 'Warning',
	DETAILS_ORDERS_FIELD_BLOCKED: 'Bloccato',

	DETAILS_ORDERS_FIELD_PRICINGGROUP: 'Listino prezzi',
	DETAILS_ORDERS_FIELD_DISCOUNTGROUP: 'Gruppo sconti',
	DETAILS_ORDERS_FIELD_PAYMENTTERMS: 'Termini di pagamento',
	DETAILS_ORDERS_FIELD_PAYMENTMETHOD: 'Metodo di pagamento',
	DETAILS_ORDERS_FIELD_SHIPPINGMETHOD: 'Metodo di spedizione',
	DETAILS_ORDERS_FIELD_SHIPPINGAGENT: 'Spedizioniere',
	DETAILS_ORDERS_FIELD_EXTERNAL_NUMBER: 'Codice esterno',
	DETAILS_ORDERS_FIELD_DATE_DATE_REQDELIVERY: 'Data consegna richiesta',
	// #endregion

	// #region Orders Lines
	DETAILS_ORDERS_LINES_FIELD_ORDER_STATUS: 'Stato Ordine',
	DETAILS_ORDERS_LINES_FIELD_ERP_ID: 'Codice ERP',
	// DETAILS_ORDERS_LINES_FIELD_ERP_ID: 'Codice NAV',
	DETAILS_ORDERS_LINES_FIELD_TYPE: 'Tipo',
	DETAILS_ORDERS_LINES_FIELD_TYPE_ITEM: 'Prodotto',
	DETAILS_ORDERS_LINES_FIELD_TYPE_WORKREPORTS: 'Servizio',
	DETAILS_ORDERS_LINES_FIELD_TYPE_NOTE: 'Nota',
	DETAILS_ORDERS_LINES_FIELD_DESCRIPTION: 'Descrizione',
	DETAILS_ORDERS_LINES_FIELD_ORDER: 'Ordine',
	DETAILS_ORDERS_LINES_FIELD_ITEM: 'Prodotto',
	DETAILS_ORDERS_LINES_FIELD_SERVICE_TYPE: 'Tipo servizio',
	DETAILS_ORDERS_LINES_FIELD_ITEM_SERIES: 'Serie',
	DETAILS_ORDERS_LINES_FIELD_ITEM_MEASURES: 'Misure',
	DETAILS_ORDERS_LINES_FIELD_BASE_PRICE: 'Prezzo base',
	DETAILS_ORDERS_LINES_FIELD_DISCOUNT: 'Sconto',
	DETAILS_ORDERS_LINES_FIELD_UNIT_PRICE: 'Prezzo unitario',
	DETAILS_ORDERS_LINES_FIELD_QUANTITY: 'Quantità',
	DETAILS_ORDERS_LINES_FIELD_ISCUSTOM: 'Prezzo custom',
	DETAILS_ORDERS_LINES_FIELD_ITEM_UNITOFMEASURE: 'UM',
	DETAILS_ORDERS_LINES_FIELD_TOT_TAX_EXCL: 'Prezzo totale (tasse escluse)',
	DETAILS_ORDERS_LINES_FIELD_UNIT_EXPENSES: 'Costo unitario (previsto)',
	DETAILS_ORDERS_LINES_FIELD_TOT_EXPENSES: 'Costo totale (previsto)',
	DETAILS_ORDERS_LINES_FIELD_PROJECT: 'Progetto collegato',
	DETAILS_ORDERS_LINES_FIELD_MERCHPOINTS: 'Punti Merchandise',

	DETAILS_ORDERS_LINES_ORIGINAL_VALUE: 'Listino: {value}',

	DETAILS_ORDERS_LINES_FIELD_ERROR_OUTDATED_PRICE: 'Prezzo non aggiornato',
	DETAILS_ORDERS_LINES_FIELD_ERROR_UNAVAILABLE: 'Articolo non disponibile',

	DETAILS_ORDERS_LINES_BUTTON_ADD_ITEM: 'Aggiungi Prodotto',
	DETAILS_ORDERS_LINES_BUTTON_ADD_PRICING_ITEMS: 'Aggiungi Prodotti da listino',
	DETAILS_ORDERS_LINES_BUTTON_ADD_SERVICE: 'Aggiungi Servizio',
	DETAILS_ORDERS_LINES_BUTTON_ADD_NOTE: 'Aggiungi Nota',
	DETAILS_ORDERS_LINES_BUTTON_ADD_STANDARD_NOTES: 'Aggiungi Blocco commenti generici',
	DETAILS_ORDERS_LINES_BUTTON_ADD_PROJECT: 'Crea Progetto',
	DETAILS_ORDERS_LINES_BUTTON_ADD_INVOICE: 'Crea Fattura',
	DETAILS_ORDERS_LINES_BUTTON_DELETE_LINE: 'Rimuovi righe',

	DIALOG_ORDERS_LINES_DIALOG_ADD_TITLE: 'Aggiungi riga',
	DIALOG_ORDERS_LINES_DIALOG_ADD_ITEMS_TITLE: 'Seleziona i Prodotti da aggiungere',
	DIALOG_ORDERS_LINES_DIALOG_ADD_NOTE_TITLE: 'Aggiungi Nota',
	DIALOG_ORDERS_LINES_DIALOG_ADD_STANDARD_NOTES_TITLE: 'Aggiungi Blocco commenti generici',
	DIALOG_ORDERS_LINES_DIALOG_EDIT_TITLE: 'Modifica riga',

	DETAILS_ORDERS_LINES_LOTS_MIN_QTY: 'Quantità minima',
	DETAILS_ORDERS_LINES_LOTS_UNIT_PRICE: 'Prezzo unitario',

	ORDERS_LINES_EDIT_DIALOG_PRICE_SECTION: 'Prezzo',
	ORDERS_LINES_EDIT_DIALOG_EXPENSES_SECTION: 'Costo',
	ORDERS_LINES_EDIT_DIALOG_PROJECT_SECTION: 'Progetto',

	ORDERS_ACTION_EDIT_LINES: 'Modifica',
	// #endregion

	// #region Orders Billing
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE: 'Fase fatturazione',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_DATE: 'Data fissa',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_SIGNED: 'Firma Ordine',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_MILESTONE: 'Fase Progetto',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_MILESTONE_VALUE: 'Progetto - {value}',
	DETAILS_ORDERS_BILLING_FIELD_SCHEDULE_DATE_FINAL: 'Data',
	DETAILS_ORDERS_BILLING_FIELD_ORDER: 'Ordine',
	DETAILS_ORDERS_BILLING_FIELD_ORDER_LINE: "Riga d'Ordine",
	DETAILS_ORDERS_BILLING_FIELD_PROJECT: 'Progetto',
	DETAILS_ORDERS_BILLING_FIELD_COMPANY: 'Azienda',
	DETAILS_ORDERS_BILLING_FIELD_DESCRIPTION: 'Descrizione',
	DETAILS_ORDERS_BILLING_FIELD_PAYMENTMETHOD: 'Metodo di pagamento',
	DETAILS_ORDERS_BILLING_FIELD_PAYMENTTERMS: 'Termini di pagamento',
	DETAILS_ORDERS_BILLING_FIELD_INVOICE_TYPE: 'Tipo Fattura',
	DETAILS_ORDERS_BILLING_FIELD_TYPE: 'Tipologia fatturazione',
	DETAILS_ORDERS_BILLING_FIELD_TYPE_QUANTITY: 'Quantità',
	DETAILS_ORDERS_BILLING_FIELD_TYPE_PERCENTAGE: 'Percentuale',
	DETAILS_ORDERS_BILLING_FIELD_TYPE_AMOUNT: 'Fisso',
	DETAILS_ORDERS_BILLING_FIELD_QUANTITY: 'Quantità',
	DETAILS_ORDERS_BILLING_FIELD_PERCENTAGE: 'Percentuale',
	DETAILS_ORDERS_BILLING_FIELD_AMOUNT: 'Importo',
	DETAILS_ORDERS_BILLING_FIELD_BILLABLE: 'Fatturabile',
	DETAILS_ORDERS_BILLING_FIELD_BILLED_DATE: 'Data fattura',
	DETAILS_ORDERS_BILLING_FIELD_INVOICE: 'Fattura',

	DETAILS_ORDERS_BILLING_BUTTON_ADD_LINE: 'Aggiungi riga fatturazione',
	DETAILS_ORDERS_BILLING_BUTTON_DELETE_LINE: 'Rimuovi righe fatturazione',

	DIALOG_ORDERS_BILLING_DIALOG_ADD_TITLE: 'Aggiungi riga fatturazione',
	DIALOG_ORDERS_BILLING_DIALOG_EDIT_TITLE: 'Modifica riga fatturazione',

	ORDERS_ACTION_EDIT_BILLING: 'Modifica',
	// #endregion

	// #region Details Billing Company section
	DETAILS_BILLING_COMPANY_SECTION: 'Indirizzo di fatturazione',
	DETAILS_BILLING_COMPANY_SUBHEADER: "Visualizza l'indirizzo di fatturazione",
	// #endregion

	// #region Details Shipping Company section
	DETAILS_SHIPPING_ADDRESS_SECTION: 'Indirizzo di spedizione',
	DETAILS_SHIPPING_ADDRESS_SUBHEADER: "Visualizza e modifica l'indirizzo di spedizione",
	// #endregion

	// #region Details Notes section
	DETAILS_NOTES_SECTION: 'Note',
	DETAILS_NOTES_SUBHEADER: 'Visualizza e modifica le note per il corriere',
	// #endregion

	// #region Details Comments section
	DETAILS_COMMENTS_SECTION: 'Commenti',
	DETAILS_COMMENTS_SUBHEADER: "Visualizza e modifica i commenti per l'operatore interno",
	// #endregion

	// #region Details Check rows section
	ORDERS_DETAILS_CHECKROWS_TITLE: 'Rilevata variazione listini',
	ORDERS_DETAILS_CHECKROWS_TEXT1: 'I prezzi e/o la disponibilità di alcuni articoli sono cambiati ',
	ORDERS_DETAILS_CHECKROWS_TEXT2: 'premi "Aggiorna prezzi" per ricalcolare le righe o rimuovile manualmente',
	ORDERS_DETAILS_CHECKROWS_ACTION: 'Aggiorna prezzi',
	ORDERS_DETAILS_CHECKROWS_DIALOG: 'Sei sicuro di voler ricalcolare i prezzi?',
	// #endregion

	// #region Orders general stats section
	ORDS_SECTION_BILLING_STATS_TITLE: 'Statistiche Ordine',

	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED: 'Fatturato previsto',
	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED_INVOICES: 'di cui Prodotti',
	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED_WORKREPORTS: 'di cui Servizi',
	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED_OTHER: 'di cui altro',
	ORDS_SECTION_BILLING_STATS_VALUE_PLANNED_MISSING: 'da fatturare',

	ORDS_SECTION_BILLING_STATS_VALUE_FINAL: 'Fatturato attuale',

	ORDS_SECTION_BILLING_STATS_EXPENSES_PLANNED_TOTAL: 'Costo previsto',
	ORDS_SECTION_BILLING_STATS_EXPENSES_PLANNED_INVOICES: 'di cui Prodotti',
	ORDS_SECTION_BILLING_STATS_EXPENSES_PLANNED_WORKREPORTS: 'di cui Servizi',
	ORDS_SECTION_BILLING_STATS_EXPENSES_PLANNED_MISSING: 'da fatturare',

	ORDS_SECTION_BILLING_STATS_EXPENSES_TOTAL: 'Costo attuale',
	ORDS_SECTION_BILLING_STATS_EXPENSES_INVOICES: 'di cui Prodotti',
	ORDS_SECTION_BILLING_STATS_EXPENSES_WORKREPORTS: 'di cui Servizi',
	ORDS_SECTION_BILLING_STATS_EXPENSES_OTHER: 'di cui altro',

	ORDS_SECTION_BILLING_STATS_PROFIT_PLANNED: 'Margine previsto',
	ORDS_SECTION_BILLING_STATS_PROFIT_PLANNED_INVOICES: 'da Prodotti',
	ORDS_SECTION_BILLING_STATS_PROFIT_PLANNED_WORKREPORTS: 'da Servizi',
	ORDS_SECTION_BILLING_STATS_PROFIT_FINAL: 'Margine attuale',

	// #region Orders Min Value section
	ORDERS_MIN_VALUE_SECTION_TITLE: "Minimo d'ordine: {value}",
	ORDERS_MIN_VALUE_SECTION_PROGRESS: "Per poter confermare l'ordine mancano {value}",

	ORDERS_MIN_VALUE_ERROR: "Minimo d'ordine non raggiunto",
	// #endregion

	// #region Orders Shipping charges
	ORDERS_SHIPPINGCHARGES_SECTION_TITLE: 'Spese di trasporto: {value}',
	ORDERS_SHIPPINGCHARGES_SECTION_SUBTITLE: 'Nazione di destinazione: {country}',
	ORDERS_SHIPPINGCHARGES_SECTION_PROGRESS: 'Per la spedizione gratuita mancano {value}',

	TAB_SHIPPINGCHARGES: 'Spese trasporto',
	ORDERS_SHIPPINGCHARGES_ADD: 'Aggiungi Spese di trasporto',
	ORDERS_SHIPPINGCHARGES_UPDATE: 'Modifica Spese di trasporto',

	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_COUNTRY: 'Nazione',
	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_VALUE: 'Spese',
	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_TOT_VALUE_FROM: 'Imponibile minimo',
	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_TOT_VALUE_TO: 'Imponibile massimo',
	DETAILS_ORDERS_SHIPPINGCHARGES_FIELD_DISABLED: 'Disabilitata',
	// #endregion

	// #region Orders Merch Points
	ORDERS_MERCHPOINTS_SECTION_TITLE: 'Punti merchandise usati:',
	DIALOG_ORDERS_MERCH_ADD_TITLE: 'Seleziona il merchandise',
	DIALOG_ORDERS_MERCH_TABLE_FOOTER: 'Punti Merchandise: {spent}/{earned}',

	ORDERS_MERCHPOINTS_ERROR: 'Stai usando più Punti Merchandise di quanti siano disponibili!',

	DETAILS_ORDERS_MERCH_FIELD_ERP_ID: 'Codice NAV',
	DETAILS_ORDERS_MERCH_FIELD_ITEM: 'Prodotto',
	DETAILS_ORDERS_MERCH_FIELD_QUANTITY: 'Quantità',
	DETAILS_ORDERS_MERCH_FIELD_UNIT_PRICE: 'Punti unitari',
	DETAILS_ORDERS_MERCH_FIELD_TOT_PRICE: 'Punti totali',
	// #endregion

	// #region Orders Promos
	ORDERS_PROMOS_GROUP_ITEM_TITLE: 'Imponibile minimo: {value}',
	ORDERS_PROMOS_GROUP_ITEM_TITLE2: 'Imponibile massimo: {value}',
	ORDERS_PROMOS_GROUP_ITEM_SUBHEADER: 'Mancano {value}',
	ORDERS_PROMOS_TYPE_DISCOUNT_LABEL: 'Extrasconto +{value}',

	TAB_PROMOS: 'Promozioni',
	ORDERS_PROMOS_ADD: 'Aggiungi Promozione',
	ORDERS_PROMOS_ADD_ROW: 'Aggiungi riga',

	ORDERS_PROMOS_TYPE_ITEMS: 'Prodotti omaggio',
	ORDERS_PROMOS_TYPE_DISCOUNTS: 'Extrasconto',
	ORDERS_PROMOS_TYPE_NOTES: 'Note',

	DETAILS_ORDERS_PROMOS_FIELD_TITLE: 'Titolo',
	DETAILS_ORDERS_PROMOS_FIELD_DESCRIPTION: 'Descrizione',
	DETAILS_ORDERS_PROMOS_FIELD_DATE_FROM: 'Data inizio',
	DETAILS_ORDERS_PROMOS_FIELD_DATE_TO: 'Data fine',
	DETAILS_ORDERS_PROMOS_FIELD_TYPE: 'Tipo',
	DETAILS_ORDERS_PROMOS_FIELD_DISABLED: 'Disabilitata',
	DETAILS_ORDERS_PROMOS_FIELD_EXPIRED: 'Scaduta',

	DETAILS_ORDERS_PROMOS_FIELD_ACTIVE: 'In corso',

	ORDERS_PROMOS_ROWS_COLUMN_ITEM: 'Prodotto',
	ORDERS_PROMOS_ROWS_COLUMN_QUANTITY: 'Quantità',
	ORDERS_PROMOS_ROWS_COLUMN_DISCOUNT: 'Extrasconto',
	ORDERS_PROMOS_ROWS_COLUMN_NOTE: 'Nota',
	ORDERS_PROMOS_ROWS_COLUMN_TOT_VALUE_FROM: 'Imponibile minimo',
	ORDERS_PROMOS_ROWS_COLUMN_TOT_VALUE_TO: 'Imponibile massimo',
	// #endregion

	// #region Orders Standard Notes
	TAB_STANDARDNOTES: 'Commenti generici',
	ORDERS_STANDARDNOTES_ADD: 'Aggiungi Blocco commenti generici',
	ORDERS_STANDARDNOTES_ADD_ROW: 'Aggiungi riga',

	DETAILS_ORDERS_STANDARDNOTES_FIELD_TITLE: 'Titolo',

	ORDERS_STANDARDNOTES_ROWS_COLUMN_DESCRIPTION: 'Descrizione',
	ORDERS_STANDARDNOTES_ROWS_COLUMN_ORDER: 'Ordine'
	// #endregion
};

export default locale;
